/* eslint-disable no-useless-escape */
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter, useHistory } from "react-router-dom";
import { Form, Formik } from "formik";
import { pathOr, includes } from "ramda";
import * as Yup from "yup";
import * as jwt from "jsonwebtoken";

import UserService from "../../service/UserService";
import loginService from "../../service/login";
import { LoginSagaAction } from "../../sagas/saga-actions";
import { setPopup } from "../../actions/popupAction";
import CustomButton from "../customButton";
import CustomNotification from "../notification";
import LoginLeftSection from "../loginLeftSection";
import { SingleFormikSelect } from "../select/singleSelect";
import { getCookie, removeCookie } from "../../helper/helpers";
import { LIVECHAT_DOMAIN, TOKEN_NAMES } from "../../constants/constants";

const LoginByDept = (props) => {
  const userservice = new UserService();
  const history = useHistory();

  const [state, setState] = useState({
    initialValues: {
      subAccountName: "",
      deptName: "",
    },
    subAccountList: [],
    deptList: [],
  });

  const msToken = getCookie("ms-lc-token");
  const decodedMSToken = jwt.decode(msToken, { complete: true });

  const { customPopupMessage, messageType, message } = props.popupReducer;
  const mainOrSub =
    props?.location?.state?.mainOrSub || decodedMSToken?.payload?.mainOrSub;
  const role =
    props?.location?.state?.role || decodedMSToken?.payload?.roles?.roleKey;

  const roleType = props?.location?.state?.roleType || "";

  const inputSchema = Yup.object().shape({
    subAccountName:
      (mainOrSub === "1" || role === "CA" || role === "HA") &&
      Yup.object().shape({
        id: Yup.string().required("Sub Account name is required"),
      }),
    deptName: Yup.object().shape({
      id: Yup.string().required("Department name is required"),
    }),
  });
  const checkOtp = async () => {
    if (
      !userservice.getToken() &&
      !userservice.getMsToken() &&
      !userservice.getSSOToken()
    ) {
      history.push("/");
    }
  };

  const checkLogin = async () => {
    if (loginService.isLoggedin() && !userservice.getMsToken()) {
      const ssoToken = userservice.getSSOToken();
      const decodedSsoToken = jwt.decode(ssoToken, { complete: true });
      if (
        !ssoToken ||
        (ssoToken &&
          !decodedSsoToken?.payload.directLoginLC &&
          decodedSsoToken?.payload.department)
      ) {
        history.push("/chat");
      }
    }
  };

  useEffect(() => {
    checkLogin();
    checkOtp();
  }, []);

  const handleGoBack = () => {
    userservice.removeToken();
    userservice.removeMsTokens();
    userservice.removeSSOToken();
    history.push("/");
  };

  const handleSubmit = async (values, e) => {
    e.preventDefault();
    try {
      const obj =
        mainOrSub === "0" && ["CR", "CL"].includes(role)
          ? {
              department: values?.deptName?.id,
            }
          : {
              account: values?.subAccountName?.id,
              department: values?.deptName?.id,
            };
      const response = await userservice.loginWithDept(obj);
      if (response.hasOwnProperty("success") && !response.success) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: response.message,
        });
        return;
      }
      const { userDetails } = response.data;
      if (!userDetails.practiceId) {
        props.setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: `Invalid credentials!`,
        });
        return;
      }
      if (userDetails?.lcUser) {
        loginService.doAdminLogin(userDetails, "", "");
      } else {
        loginService.doLogin(userDetails, "", "");
      }
      props.LoginSagaAction(userDetails);
      props.setPopup({
        customPopupMessage: true,
        messageType: "success",
        message: `${loginService &&
          loginService.getName()} logged in Successfully`,
      });
      removeCookie(
        TOKEN_NAMES.MS,
        process.env.REACT_APP_ENV !== "dev" && { domain: LIVECHAT_DOMAIN },
        false
      );
      removeCookie(
        TOKEN_NAMES.MS_LOGIN,
        process.env.REACT_APP_ENV !== "dev" && { domain: LIVECHAT_DOMAIN },
        false
      );

      const {
        liveChatAccess,
        broadcastAccess,
        liveAgentAccess,
        reportOnlyAccess,
      } = userDetails;
      if (liveChatAccess || reportOnlyAccess) {
        history.push("/chat");
      } else if (liveAgentAccess) {
        history.push("/chat-agent");
      } else if (broadcastAccess || reportOnlyAccess) {
        history.push("/broadcast");
      } else {
        loginService.Logout();
        props.setPopup({
          customPopupMessage: true,
          message: "You do not have access",
          messageType: "error",
        });
        history.push("/login");
      }
    } catch (err) {
      if (
        includes(
          401,
          pathOr(
            "Internal Server Error. Please check the connection",
            ["response", "data", "error"],
            err
          )
        )
      ) {
        history.push("/login");
      }
      props.setPopup({
        customPopupMessage: true,
        message: pathOr(
          "Internal Server Error. Please check the connection",
          ["response", "data", "message"],
          err
        ),
        messageType: "error",
      });
    }
  };

  const subAccountOptions = [
    {
      id: "all",
      name: "All",
    },
    {
      id: "main",
      name: "Main",
    },
  ];

  const fetchSubAccounts = (page = 1, searchQuery, isScrolling) => {
    return new Promise(async (resolve, reject) => {
      if (!(mainOrSub === "0" && ["CR", "CL", "BA"].includes(role))) {
        try {
          let {
            rows: subAccountList = [],
            count = 0,
          } = await userservice.getSubAccounts(page, searchQuery);

          if (["HA", "CA"].includes(role)) {
            subAccountList = [...subAccountOptions, ...subAccountList];
          }

          if (["CR"].includes(role)) {
            if (roleType !== "external") {
              subAccountList = [...subAccountOptions, ...subAccountList];
            } else if (roleType === "external" && subAccountList.length === 0) {
              subAccountList = [...subAccountOptions];
            }
          }

          setState((st) => ({
            ...st,
            subAccountList: isScrolling
              ? [...st.subAccountList, ...subAccountList]
              : subAccountList,
          }));
          resolve(count);
        } catch (err) {
          reject(err);
          props.setPopup({
            customPopupMessage: true,
            message: pathOr(
              "Internal Server Error. Please check the connection",
              ["response", "data", "message"],
              err
            ),
            messageType: "error",
          });
        }
      } else {
        resolve([]);
      }
    });
  };

  return (
    <div data-testid="login-page-wrapper" className="login-page-wrapper">
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      <main className="login-page-main">
        <LoginLeftSection />

        <section className="form-wrapper">
          <Formik
            enableReinitialize
            initialValues={state?.initialValues}
            validationSchema={inputSchema}
            validateOnMount
            isInitialValid={!!state?.isInitialValid}
          >
            {({ isValid, values, setFieldValue, validateForm }) => {
              const fetchDepartments = (page = 1, searchQuery, isScrolling) => {
                const { id } = values?.subAccountName || {};
                return new Promise(async (resolve, reject) => {
                  if (
                    id ||
                    (mainOrSub === "0" && ["CR", "CL", "BA"].includes(role))
                  ) {
                    try {
                      const {
                        rows: deptList = [],
                        count: deptCount = 0,
                      } = await userservice.getDepartments(
                        id,
                        page,
                        searchQuery
                      );
                      setState((st) => ({
                        ...st,
                        deptList: isScrolling
                          ? [...st.deptList, ...deptList]
                          : deptList,
                      }));
                      resolve(deptCount);
                    } catch (err) {
                      reject(err);
                      props.setPopup({
                        customPopupMessage: true,
                        message: pathOr(
                          "Internal Server Error. Please check the connection",
                          ["response", "data", "message"],
                          err
                        ),
                        messageType: "error",
                      });
                    }
                  } else {
                    resolve(0);
                    setFieldValue("deptName", {});
                    setState((st) => ({
                      ...st,
                      userList: [],
                    }));
                  }
                });
              };

              return (
                <Form className="login-form">
                  <section className="custom-input-group name-field">
                    <SingleFormikSelect
                      data={state.subAccountList}
                      name="subAccountName"
                      onChange={() => {
                        setTimeout(validateForm, 0);
                        setFieldValue("deptName", {});
                        setState((st) => ({
                          ...st,
                          deptList: [],
                        }));
                      }}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder={
                        mainOrSub === "0" && ["CR", "CL", "CA"].includes(role)
                          ? "Main Account"
                          : "Select sub account name"
                      }
                      required
                      title="Sub Account Name"
                      infiniteScroll
                      loadMoreData={fetchSubAccounts}
                      disabled={
                        mainOrSub === "0" && ["CR", "CL", "BA"].includes(role)
                          ? true
                          : false
                      }
                    />
                  </section>

                  <section className="custom-input-group name-field">
                    <SingleFormikSelect
                      data={state.deptList}
                      name="deptName"
                      key={values.subAccountName?.id}
                      onChange={() => setTimeout(validateForm, 0)}
                      optionLabelProp="name"
                      optionValueProp="id"
                      placeholder="Select department name"
                      required
                      title="Department Name"
                      infiniteScroll
                      loadMoreData={fetchDepartments}
                    />
                  </section>

                  <article className="otp-buttons">
                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      className={!isValid ? "disable-button" : ""}
                      disabled={!isValid}
                      title="Submit"
                      onClick={(e) => handleSubmit(values, e)}
                    />
                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      className="cancel-button ml-8"
                      onClick={handleGoBack}
                      title="Go Back"
                    />
                  </article>
                </Form>
              );
            }}
          </Formik>
        </section>
      </main>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    LoginSagaAction: (data) => {
      dispatch(LoginSagaAction(data));
    },
    setPopup: (data) => dispatch(setPopup(data)),
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginByDept)
);
